import { render, staticRenderFns } from "./ysxy.vue?vue&type=template&id=4e288a33&scoped=true&"
import script from "./ysxy.vue?vue&type=script&lang=js&"
export * from "./ysxy.vue?vue&type=script&lang=js&"
import style0 from "./ysxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ysxy.vue?vue&type=style&index=1&id=4e288a33&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e288a33",
  null
  
)

export default component.exports